import React from 'react';

const capitalStyle = { fontFamily: "'Livvic', sans-serif", fontWeight: 700 };
const lowerStyle = { fontFamily: "'Livvic', sans-serif", fontWeight: 400 };

const LogoText = ({ className = '', showIcon = true, showInc = false }) => (
  <span className={`inline-flex items-center ${className}`}>
    {showIcon && (
      <img
        src="/images/instruvia-logo.png"
        alt=""
        style={{ width: '1.4em', height: 'auto', objectFit: 'contain', marginRight: '0.3em' }}
      />
    )}
    <span>
      <span style={capitalStyle}>I</span>
      <span style={lowerStyle}>nstru</span>
      <span style={capitalStyle}>V</span>
      <span style={lowerStyle}>ia</span>
      {showInc && <> <span style={capitalStyle}>I</span><span style={lowerStyle}>nc.</span></>}
    </span>
  </span>
);

export default LogoText;
